// require('./bootstrap');

// Plugins
import "./jquery.min";
import'bootstrap/dist/js/bootstrap.min';
import 'jquery-autosize';
import "./modernizr-custom";
const flatpickr = require("flatpickr");

// SCSS
import "../sass/app.scss";


// Originals
import "./swiper";
import "./slick";
import "./perfect-scrollbar";
import "./script";
import "./flatpicker";